import { render } from "./AppWallpaper.vue?vue&type=template&id=143a507c&scoped=true"
import script from "./AppWallpaper.vue?vue&type=script&lang=js"
export * from "./AppWallpaper.vue?vue&type=script&lang=js"

import "./AppWallpaper.vue?vue&type=style&index=0&id=143a507c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a507c"]])

export default __exports__